import React, { useState, useRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import Loader from "../../../../Components/UiComponents/Loader";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import { getCustomerFields2 } from "../../../../Services/fieldsServices";
import { changeCredential } from "../../../../Services/userService";
import { useNavigate } from "react-router-dom";

const ChangePassword = (props) => {
    const [loading, setLoading] = useState(false);
    const [customerId, setCustomerId] = useState(null);
    const [accountSubModules, setAccountSubModules] = useState(null);
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState({
        current: false,
        new: false,
        confirm: false
    });
    const [endUser, setEndUser] = useState()

    const toastRef = useRef();

    useEffect(() => {
        const customerData = localStorage.getItem("enduser");
        if (customerData) {
            const customerDataInJSON = JSON.parse(customerData);
            setCustomerId(customerDataInJSON.customer);
            setEndUser(customerDataInJSON)
        } else {
            navigate("/login")
            localStorage.clear()
        }
    }, []);

    useEffect(() => {
        if (customerId) {
            getCustomer();
        }
    }, [customerId]);

    const getCustomer = async () => {
        try {
            if (customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            const customerMyAccountDAta = await getCustomerFields2(customerId);
            let displayAccountNames = [];
            if (customerMyAccountDAta && customerMyAccountDAta.data) {
                customerMyAccountDAta?.data.cust[0].modules[0].sub_modules.forEach((item) => {
                    displayAccountNames.push({ label: item.display_name.toUpperCase() });
                });
                setAccountSubModules(customerMyAccountDAta?.data.cust[0].modules[0].sub_modules[0].fields);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const { control, handleSubmit, getValues, formState: { errors }, reset } = useForm({
        mode: "onChange"
    });

    const closePopup = () => {
        reset();
        document.getElementById("current_password_value").value = "";
        document.getElementById("new_password_value").value = "";
        document.getElementById("confirm_password_value").value = "";
    };

    const togglePasswordVisibility = (field) => {
        setShowPassword((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };

    const onSubmit = async (cpData) => {
        try {
            if (endUser === null) {
                return;
            }

            var newPromptData = [];
            newPromptData.username = endUser.username;
            newPromptData.curPassword = cpData.current_password_value;
            newPromptData.newPassword = cpData.new_password_value;

            const response = await changeCredential(endUser.username, cpData.current_password_value, cpData.new_password_value);
            if (response && response?.data.success != false && response?.status === 200) {
                toastRef.current.showToast({
                    type: "success",
                    message: "Password updated Successfully",
                });
                setLoading(false)
                closePopup();
                reset();
                closePopup();
            } else {
                toastRef.current.showToast({
                    type: "error",
                    message: response?.data.message,
                });
                setLoading(false)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="cp-page">
                <div className="new-field">
                    <form >
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-2 pl-0">
                                <label className="form-label text-left">
                                    {_.find(accountSubModules, { field_name: "Current Password" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="current_password_value"
                                    control={control}
                                    rules={{
                                        required: "Current password is required",
                                        pattern: {
                                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_@.#$=!%^)(\]:\*;\?\/\,}{\\&quot;'\|<>\[&\+-])[A-Za-z\d_@.#$=!%^)(\]:\*;\?\/\,}{\\&quot;'\|<>\[&\+-]{4,8}/,
                                            message: "Password must contain uppercase, lowercase, digit, and special character",
                                        },
                                        minLength: {
                                            value: 8,
                                            message: "Password must be at least 8 characters",
                                        },
                                        maxLength: {
                                            value: 35,
                                            message: "Password must be no more than 35 characters",
                                        },
                                    }}

                                    render={({ field }) => (
                                        <div className="cp-icon">
                                            <InputTextElementElement placeholder="Current Password" id="current_password_value" type={showPassword.current ? "text" : "password"} className="w-cp"  {...field} />
                                            {field.value && (
                                                <i
                                                    className={`eye-icon pi ${showPassword.current ? "pi-eye-slash" : "pi-eye"} ml-0`}
                                                    onClick={() => togglePasswordVisibility("current")}
                                                />
                                            )}
                                        </div>
                                    )}
                                />
                                {errors.current_password_value && (
                                    <small className="text-red-500 color-red ml-1">
                                        {errors.current_password_value.message}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-2 pl-0">
                                <label className="form-label text-left">
                                    {_.find(accountSubModules, { field_name: "New Password" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="new_password_value"
                                    control={control}
                                    rules={{
                                        required: "New password is required",
                                        pattern: {
                                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_@.#$=!%^)(\]:\*;\?\/\,}{\\&quot;'\|<>\[&\+-])[A-Za-z\d_@.#$=!%^)(\]:\*;\?\/\,}{\\&quot;'\|<>\[&\+-]{4,8}/,
                                            message: "Password must contain uppercase, lowercase, digit, and special character",
                                        },
                                        minLength: {
                                            value: 8,
                                            message: "Password must be at least 8 characters",
                                        },
                                        maxLength: {
                                            value: 16,
                                            message: "Password must be no more than 16 characters",
                                        },
                                    }}
                                    render={({ field }) => (
                                        <div className="cp-icon">
                                            <InputTextElementElement placeholder="New Password" id="new_password_value" type={showPassword.new ? "text" : "password"} className="w-cp" {...field} />
                                            {field.value && (
                                                <i
                                                    className={`eye-icon pi ${showPassword.new ? "pi-eye-slash" : "pi-eye"} ml-0`}
                                                    onClick={() => togglePasswordVisibility("new")}
                                                />
                                            )}
                                        </div>
                                    )}
                                />
                                {errors.new_password_value && (
                                    <small className="text-red-500 color-red ml-1">
                                        {errors.new_password_value.message}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-2 pl-0">
                                <label className="form-label text-left">
                                    {_.find(accountSubModules, { field_name: "Confirm Password" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="confirm_password_value"
                                    control={control}
                                    rules={{
                                        required: "Confirm password is required",
                                        validate: value =>
                                            value === getValues('new_password_value') || "Passwords do not match",
                                    }}
                                    render={({ field }) => (
                                        <div className="cp-icon">
                                            <InputTextElementElement placeholder="Confirm Password" id="confirm_password_value" type={showPassword.confirm ? "text" : "password"} className="w-cp" {...field} />
                                            {field.value && (
                                                <i
                                                    className={`eye-icon  pi ${showPassword.confirm ? "pi-eye-slash" : "pi-eye"} ml-0`}
                                                    onClick={() => togglePasswordVisibility("confirm")}
                                                />
                                            )}
                                        </div>
                                    )}
                                />
                                {errors.confirm_password_value && (
                                    <small className="text-red-500 color-red ml-1">
                                        {errors.confirm_password_value.message}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className="forget-text mt-1">
                            "Password must be a minimum of 8 characters, including at least one of the following: upper & lower case letter, number, and symbol"
                        </div>
                    </form>
                </div>
            </div>
            <div className="col pr-0 d-flex justify-end mt-20">
                <ButtonElement className="save-button" type="submit" label="Update Password" onClick={handleSubmit(onSubmit)} />
            </div>
        </div>
    );
}

export default ChangePassword;
